import { render, staticRenderFns } from "./HomeWorkUploaderComponent.vue?vue&type=template&id=3068c788&scoped=true&"
import script from "./HomeWorkUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
export * from "./HomeWorkUploaderComponent.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./HomeWorkUploaderComponent.vue?vue&type=style&index=0&id=3068c788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3068c788",
  null
  
)

export default component.exports